/**
 * RegisterView - Gere a criação de novas contas ligando ao backend em Rust.
 */
import { apiFetch } from '../api.js';

export const RegisterView = {
    render: async () => {
        return `
            <div class="auth-container animate-fade-in" style="max-width: 400px; margin: 4rem auto; padding: 2rem; background: white; border-radius: 1rem; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);">
                <div style="text-align: center; margin-bottom: 2rem;">
                    <h2 style="font-size: 1.5rem; font-weight: 700; color: #1e293b;">Criar Conta HeyWeb</h2>
                    <p style="color: #64748b;">Começa a criar os teus sites hoje.</p>
                </div>

                <form id="register-form" style="display: flex; flex-direction: column; gap: 1.25rem;">
                    <div class="form-group">
                        <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #475569; margin-bottom: 0.5rem;">Nome Completo</label>
                        <input type="text" id="reg-name" required placeholder="João Silva" 
                               style="width: 100%; padding: 0.75rem; border: 1px solid #e2e8f0; border-radius: 0.5rem; outline: none;">
                    </div>

                    <div class="form-group">
                        <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #475569; margin-bottom: 0.5rem;">E-mail</label>
                        <input type="email" id="reg-email" required placeholder="exemplo@email.com" 
                               style="width: 100%; padding: 0.75rem; border: 1px solid #e2e8f0; border-radius: 0.5rem; outline: none;">
                    </div>

                    <div class="form-group">
                        <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #475569; margin-bottom: 0.5rem;">Palavra-passe</label>
                        <input type="password" id="reg-password" required placeholder="••••••••" 
                               style="width: 100%; padding: 0.75rem; border: 1px solid #e2e8f0; border-radius: 0.5rem; outline: none;">
                    </div>

                    <button type="submit" id="btn-register" 
                            style="width: 100%; background: #3b82f6; color: white; padding: 0.75rem; border: none; border-radius: 0.5rem; font-weight: 600; cursor: pointer; transition: background 0.2s;">
                        Criar Conta
                    </button>
                </form>

                <div id="register-message" style="margin-top: 1rem; text-align: center; font-size: 0.875rem;"></div>

                <div style="margin-top: 2rem; text-align: center; border-top: 1px solid #e2e8f0; padding-top: 1.5rem;">
                    <p style="font-size: 0.875rem; color: #64748b;">Já tens conta? <a href="#login" style="color: #3b82f6; text-decoration: none; font-weight: 600;">Faz Login</a></p>
                </div>
            </div>
        `;
    },

    afterRender: async () => {
        const form = document.getElementById('register-form');
        const messageDiv = document.getElementById('register-message');

        form.addEventListener('submit', async (e) => {
            e.preventDefault();

            const userData = {
                name: document.getElementById('reg-name').value,
                email: document.getElementById('reg-email').value,
                password: document.getElementById('reg-password').value
            };

            const btn = document.getElementById('btn-register');
            btn.disabled = true;
            btn.innerText = 'A processar...';

            try {
                // Utilizando o apiFetch centralizado que aponta para o Render
                const response = await apiFetch('/auth/register', {
                    method: 'POST',
                    body: JSON.stringify(userData)
                });

                if (response.status === 201) {
                    messageDiv.style.color = '#166534';
                    messageDiv.innerText = '✅ Conta criada! A redirecionar para o Login...';

                    // Pequeno delay para o utilizador ler a mensagem de sucesso
                    setTimeout(() => window.location.hash = '#login', 2000);
                } else if (response.status === 409) {
                    messageDiv.style.color = '#991b1b';
                    messageDiv.innerText = '❌ Este e-mail já está registado.';
                    btn.disabled = false;
                    btn.innerText = 'Criar Conta';
                } else {
                    throw new Error();
                }

            } catch (error) {
                messageDiv.style.color = '#991b1b';
                messageDiv.innerText = '❌ Erro ao ligar ao servidor no Render.';
                btn.disabled = false;
                btn.innerText = 'Criar Conta';
            }
        });
    }
};